import { useIntl } from 'react-intl';
import type { BlockEditProps } from '@plone/types';

import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';

import Body from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/Body';
import type { EmbedTrekksoftData } from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/schema';

type EmbedTrekksoftEditProps = Omit<BlockEditProps, 'data'> & {
  data: EmbedTrekksoftData;
};
const Edit = (props: EmbedTrekksoftEditProps) => {
  const intl = useIntl();

  const { selected, blocksConfig, onChangeBlock, block, data } = props;

  const schema = blocksConfig[data['@type']].blockSchema({
    data,
    intl,
  });
  return (
    <div className="block embed-trekksoft-block public-ui">
      <Body content={props.properties} data={data} />

      <SidebarPortal selected={selected}>
        <BlockDataForm
          {...props}
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </div>
  );
};

export default Edit;
